import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import * as apiConfig from "../../../api/config";
import Pagination from "../../common/Pagination";
import Spinner from "../../common/Spinner";
import { loadUsers } from "../../../redux/actions/userActions";
import { getFollowRequests } from "../../../redux/actions/riderNetworkActions";
import UserAvatar from 'react-user-avatar';
import $ from 'jquery';
import FollowerStatusControl from "./FollowerStatusControl";
import FollowingStatusControl from "./FollowingStatusControl";
import FollowerRequestControl from "./FollowerRequestControl";

function ProfileNetwork({
    user,
    userNetworkSearchCriteria,
    loadUsers,
    getFollowRequests,
    subjectUser

}) {

    const [processing, setProcessing] = useState(true);
    const [resultingUsers, setResultingUsers] = useState(true);
    const [pendingRequests, setPendingRequests] = useState([]);
    const [networkMessage, setNetworkMessage] = useState("");
    const [filterMessage, setFilterMessage] = useState("");
    const [showNetworkMessage, setShowNetworkMessage] = useState(false);

    const [searchCriteria, setSearchCriteria] = useState({
        userId: subjectUser.id,
        ownProfile: subjectUser.id.toUpperCase() == user.id.toUpperCase(),
        pageNumber: "1",
        numberOfResults: "8",
        sortDirection: "ASC",
        sortBy: "UserName",
        category: "",
        keywords: "",
        searchType: "following"
    });

    useEffect(() => {
        if (!user) {
            return;
        }
        initialise();

    }, []);

    useEffect(() => {
        setProcessing(true);
        initialise();
    }, [subjectUser, user])

    function initialise(){
        if (userNetworkSearchCriteria.userId && userNetworkSearchCriteria.userId.toUpperCase() === subjectUser.id.toUpperCase()) {
            setSearchCriteria(userNetworkSearchCriteria);
            reloadUsers(userNetworkSearchCriteria)
            return;
        }
        reloadUsers(searchCriteria);
    }

    function reloadUsers(criteria) {
        setProcessing(true);
        if (subjectUser.id.toUpperCase() === user.id.toUpperCase()) {
            getFollowRequests().then((requests) => { setPendingRequests(requests); })
        }
        loadUsers(criteria)
            .then((users) => {

                var filteredUsers = []
                users.results.map(u => {
                    if (u.blocked) {
                        if (!criteria.searchType == "following" && !criteria.searchType == "followers") {
                            filteredUsers.push(u)
                        }
                    } else {
                        filteredUsers.push(u)
                    }
                })
                users.results = filteredUsers;

                if (users.results.length == 0) {

                    if (criteria.searchType == "following" && criteria.keywords == "") {
                        setNetworkMessage(
                            criteria.ownProfile ?
                                "You're not currently following anyone? Why not search for riders you know or follow one of the riders who follow you. This way you can stay up to date when they post or upload a route!"
                                :
                                `${subjectUser.firstName} is not following anyone at the moment, why not connect?`
                        )
                        setShowNetworkMessage(true);
                    } else if (criteria.searchType == "followers" && criteria.keywords == "") {
                        setNetworkMessage(
                            criteria.ownProfile ?
                                "You don't have any followers yet."
                                :
                                `${subjectUser.firstName} does not currently have any followers.`
                        )
                        setShowNetworkMessage(true);
                    }
                    else if (criteria.keywords != "") {
                        setNetworkMessage(`There are no search results for '${criteria.keywords}'`)
                        setShowNetworkMessage(true);
                    }
                }
                else {
                    setShowNetworkMessage(false);
                }
                setFilterMessage(criteria.keywords);
                setResultingUsers(users)
                setProcessing(false);
            });
    }

    function handlePageForward(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = resultingUsers.currentPage + 1
        reloadUsers(criteria);
    }

    function handlePageBack(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = resultingUsers.currentPage - 1
        reloadUsers(criteria);
    }

    function handlePageChange(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = e.target.value
        reloadUsers(criteria);
    }

    function handleChange(e) {
        var value = e.target.value

        setSearchCriteria(prevSearchCriteria => ({
            ...prevSearchCriteria,
            keywords: value
        }));
    }

    function handleSearch(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = 1;
        reloadUsers(criteria);
    }

    function handleType(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = 1;
        criteria.searchType = e.target.value
        reloadUsers(criteria);
    }


    return (
            <div className="profile-network col-12">
                <div className="search-toolbar top-form col-md-12 col-lg-12">
                    <form onSubmit={handleSearch} >
                        <div className="network-type">
                            <select className="form-control form-control-sm" id="sortBy" value={searchCriteria.searchType} onChange={handleType}>
                                <option value="following">{subjectUser.id == user.id ? `Riders I Follow` : `Riders ${subjectUser.firstName} Follows`}</option>
                                <option value="followers">{subjectUser.id == user.id ? `My Followers` : `${subjectUser.firstName}'s Followers`}</option>
                                {subjectUser.id == user.id ? <option value="all">All Users</option> : ""}
                            </select>
                        </div>
                        <div className="user-search">
                            <div className="input-group mb-0">
                                <input type="text" className="form-control form-control-sm" value={searchCriteria.keywords} onChange={handleChange} placeholder="Search..." aria-label="Keyword Search" />
                                <div className="input-group-append">
                                    <button type="submit" className="btn btn-secondary btn-sm" type="submit"><span className="fas fa-search" onClick={handleSearch}></span></button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            {processing ?
                <Spinner />
                :
                <div className="profile-results">
                    {showNetworkMessage &&
                        <div className="empty-message">
                            <span className="fas fa-user-friends empty-icon"></span>
                            <div className="empty-text">{networkMessage}</div>
                        </div>
                    }
                    {(pendingRequests.length > 0 && searchCriteria.searchType == "followers") &&
                        <div className="row justify-content-md-center mt-3">
                            <table className="table col-11">
                                <tbody>
                                    {
                                        pendingRequests.map((resultingUser, index) => {
                                            return (
                                                <tr key={resultingUser.userId}>
                                                    <td width="35px" scope="row"><UserAvatar size="35" name={`${resultingUser.firstName} ${resultingUser.surname}`} src={resultingUser.hasAvatar ? `${apiConfig.API_URL}user/avatar/${resultingUser.userId}.png` : ""} /></td>
                                                    <td><Link to={"/user/profile/" + resultingUser.userId}>{`${resultingUser.firstName} ${resultingUser.surname}`}</Link></td>
                                                    <td width="200px"><FollowerRequestControl subjectUser={resultingUser} /></td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>
                    }

                    <div className="row justify-content-md-center mt-3">
                        {filterMessage.length > 0 &&
                            <div>{`Results filtered by: '${filterMessage}'`}</div>
                        }
                        <table className="table col-11">
                            <tbody>
                                {
                                    resultingUsers.results.map((resultingUser, index) => {
                                        return (
                                            <tr key={resultingUser.userId}>
                                                <td width="35px" scope="row"><UserAvatar size="35" name={`${resultingUser.firstName} ${resultingUser.surname}`} src={resultingUser.hasAvatar ? `${apiConfig.API_URL}user/avatar/${resultingUser.userId}.png` : ""} /></td>
                                                <td><Link to={"/user/profile/" + resultingUser.userId}>{`${resultingUser.firstName} ${resultingUser.surname}`}</Link></td>
                                                {subjectUser.id == user.id &&
                                                    <td width="200px" >
                                                        {searchCriteria.searchType == "followers" ?
                                                            <FollowerStatusControl subjectUser={resultingUser} />
                                                            :
                                                            <FollowingStatusControl subjectUser={resultingUser} />
                                                        }
                                                    </td>
                                                }
                                            </tr>
                                        );
                                    })}
                            </tbody>

                        </table>

                    </div>
                    {resultingUsers.totalResults > resultingUsers.pageSize &&
                        <Pagination
                            totalResults={resultingUsers.totalResults}
                            currentPage={resultingUsers.currentPage}
                            pageSize={resultingUsers.pageSize}
                            onPageBack={handlePageBack}
                            onPageForward={handlePageForward}
                            onChangePage={handlePageChange}
                        />
                    }

                </div>
            }
        </div>
          
       

    );


}

ProfileNetwork.propTypes = {
    user: PropTypes.object.isRequired,
    getFollowRequests: PropTypes.func.isRequired,
    userNetworkSearchCriteria: PropTypes.object,
    loadUsers: PropTypes.func.isRequired,
    subjectUser: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
    return {
        user: state.user,
        userNetworkSearchCriteria: state.userNetworkSearchCriteria
    };
}

const mapDispatchToProps = {
    loadUsers,
    getFollowRequests
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileNetwork);

/*
if (user.riderNetwork.following.length === 0 && user.riderNetwork.followers.length === 0) {
    setNetworkMessage(
        user.id.toUpperCase() === subjectUser.id.toUpperCase() ?
            "Your rider network is looking a little lonely.Search for some riders to connect with and start planning your next ride!"
            :
            `${subjectUser.firstName} does not currently have any followers.`
    )
    setShowNetworkMessage(true);
} else if (user.riderNetwork.following.length === 0) {
    setNetworkMessage(
        user.id.toUpperCase() === subjectUser.id.toUpperCase() ?
            "You're not currently following anyone? Why not follow one of the riders who follow you. This you can stay up to date when they post or upload a route!"
            :
            `${subjectUser.firstName} is not following anyone at the moment, why not connect?`
    )
    setShowNetworkMessage(true);
} else {
    setNetworkMessage("You don't have any followers yet.")
    setShowNetworkMessage(true);
}
*/


// WEBPACK FOOTER //
// ./src/components/user/profile/ProfileNetwork.js